jQuery(document).ready(function($) {
  var $wrapper = $('.partners-block-wrapper');
  var $originalItems = $wrapper.children(); // logos PHP originaux
  var $itemsClone = $originalItems.clone();

  // Créer le track
  var $track = $('<div class="partners-block-track"></div>');
  $track.append($originalItems);

  // Dupliquer 4x pour remplir l’écran
  for (var i = 0; i < 4; i++) {
    $track.append($itemsClone.clone());
  }

  $wrapper.empty().append($track);

  // Mesurer la largeur de la liste originale
  var originalWidth = 0;
  $track.children().slice(0, $itemsClone.length).each(function() {
    originalWidth += $(this).outerWidth(true);
  });

  // Définir la durée d’animation (ajuste 100 = vitesse en px/sec)
  var duration = originalWidth / 100;

  // Injecter la keyframe dynamique
  var style = document.createElement('style');
  style.innerHTML = `
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${originalWidth}px); }
    }
    .partners-block-track {
      animation: marquee ${duration}s linear infinite;
    }
  `;
  document.head.appendChild(style);
});